// Top-level domains a bare domain in a post may end with (AMR-414). A short, known list,
// so that abbreviations and file names ("t.ex.", "rapport.pdf") stay text.
export const BARE_DOMAIN_TLDS = ["se", "com", "nu", "no", "dk", "fi", "org", "net", "io"];

export type BareDomainPart = string | { text: string; href: string };

const label = "[\\p{L}\\p{N}](?:[\\p{L}\\p{N}-]*[\\p{L}\\p{N}])?";

// Not after a letter, digit, "@" (e-mail), "." or "/" (part of something longer), then
// labels, a known TLD, an optional path, and not followed by more of a name.
const bareDomainPattern = new RegExp(
    "(^|[^\\p{L}\\p{N}_@./:-])" +
    "((?:" + label + "\\.)+(?:" + BARE_DOMAIN_TLDS.join("|") + ")(?:/[^\\s<>\"']*)?)" +
    "(?![\\p{L}\\p{N}_-]|\\.[\\p{L}\\p{N}])",
    "giu",
);

const trailingPunctuation = /[.,!?;:)\]]+$/;

/**
 * Splits text into plain parts and bare domains ("nordiskalivsstil.se/hosten") with an
 * https link. Text that already is a link ("https://…", "www.…") is linked before this.
 */
export default function splitBareDomains(text: string): BareDomainPart[] {
    const parts: BareDomainPart[] = [];
    let last = 0;

    for (const match of text.matchAll(bareDomainPattern)) {
        let domain = match[2];
        const trailing = domain.indexOf("/") > -1 ? (domain.match(trailingPunctuation)?.[0] || "") : "";

        domain = domain.slice(0, domain.length - trailing.length);

        const start = match.index + match[1].length;

        if (start > last) {
            parts.push(text.slice(last, start));
        }

        parts.push({ text: domain, href: "https://" + domain });
        last = start + domain.length;
    }

    if (last < text.length) {
        parts.push(text.slice(last));
    }

    return parts;
}
